import { HelpParameters, Help, HelpPanelColor } from "../../help/Help";
import { IHelpFactory } from "../../help/IHelpFactory";
import { MultigameParams } from "../../MultigameParams";
import { SlotGameInitData } from "../../SlotGameInitData";
import { IPanelFactory, PanelParams } from "../panel/IPanelFactory";
import { Panel, ButtonColors } from "../panel/panel";
import { RewardColor } from "../ScatterRandomAward/RewardOptionFactory";
import { SlotGameType1_2Screen } from "../SlotGameType1_2Screen";
import { IWinLinesFactory } from "../WinLines/IWinLinesFactory";
import { MarkersInfoColors, } from "../WinLineInfoMarkers";
import { WinSquareMarkesAnimations } from "../WinLines/WinSquaresMarkersAnimations";
import { WinLinesAnimationParams } from "../WinLines/GenericWinLinesAnimation";
// namespace SlotGames {
export class RoyalKing_2Screen extends SlotGameType1_2Screen {


    //protected override helpFactory: IHelpFactory = new RoyalKingHelpFactory();

    //protected override panelFactory: IPanelFactory = new RoyalKingPanelFactory();

    //LED COLOR
    protected override ColorLed: string = "250,0,0\n";

    constructor(multigameParams: MultigameParams, initData: SlotGameInitData) {
        super(multigameParams, initData, "RoyalKing");
        this.spinnableReelsParams.topBorderWidth = 0;
        this.spinnableReelsParams.bottomBorderWidth = 0;
    }
   
    //SEND COLOR 
    protected override color: RewardColor =
        {
            color: "white",
            coloroutherStroke: "black",
            colorinnerStroke: "red",
        }

}

//Help Colorized
class RoyalKingHelpFactory implements IHelpFactory {
    public CreateNewHelp(params: HelpParameters): Help {
        return new RoyalKingHelp(params);
    }
}

class RoyalKingHelp extends Help {
    protected override BackgroundPanel(): HelpPanelColor {
        let color: HelpPanelColor = {
            backgroundPanelColor: "linear-gradient(rgb(15,19,89),rgb(45,51,166), rgb(90,97,242),rgb(45,51,166),rgb(15,19,89)), linear-gradient( #BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C)",
        };

        return color;
    }
}

//Panel Colorized
class RoyalKingPanelFactory implements IPanelFactory {
    public CreateNewPanel(params: PanelParams): Panel {
        return new RoyalKingPanel(params);
    }
}

class RoyalKingPanel extends Panel {
    protected override ButtonBackground(): ButtonColors {
        let color: ButtonColors = {
            backgroundButtonColor: "linear-gradient(rgb(38, 15, 15),rgb(89, 14, 14), rgb(140, 15, 15),rgb(89, 14, 14),rgb(38, 15, 15)), linear-gradient( #BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C)",
            linearColor: "linear-gradient(to left , transparent, rgb(242, 115, 41),transparent ) 0 10 100%",
        };
        return color;

    }

}

class RoyalKingMarkersFactory implements IWinLinesFactory {
    public CreateWinLines(params: WinLinesAnimationParams): WinSquareMarkesAnimations {
        return new RoyalKingMarkers(params);
    }
}


class RoyalKingMarkers extends WinSquareMarkesAnimations {
    protected override MarkesInfoBackground(): MarkersInfoColors {
        let color: MarkersInfoColors = {
            MarkerbackgroundColor: "linear-gradient(90deg, rgba(65,6,6,1) 0%, rgba(255,9,9,1) 35%, rgba(255,153,9,1) 55%, rgba(255,21,9,1) 75%, rgba(65,9,6,1) 100%), linear-gradient( #BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C)",
        };
        return color;
    }

}

// }
